var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFingerHangUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.7,
    fill: "#E9A011",
    stroke: "transparent",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.325 14.845a.286.286 0 1 0-.569.077 7.021 7.021 0 0 1-2.161 6.056.288.288 0 0 0 .392.42 7.597 7.597 0 0 0 2.338-6.553zM8.163 15.18a.31.31 0 0 0-.011-.039 6.074 6.074 0 0 1-.106-.902.287.287 0 1 0-.574.024c.014.344.056.691.125 1.032a.258.258 0 0 0 .01.039 2.846 2.846 0 0 1-.958 2.693.288.288 0 0 0 .372.439 3.422 3.422 0 0 0 1.142-3.285zM9.778 17.47a.287.287 0 0 0-.372.164A4.955 4.955 0 0 1 7.93 19.67a.287.287 0 0 0 .365.444 5.537 5.537 0 0 0 1.646-2.272.288.288 0 0 0-.163-.372zM7.108 9.324a.286.286 0 0 0 .401-.062 8.015 8.015 0 0 1 4.902-3.14 7.953 7.953 0 0 1 5.124.66.287.287 0 1 0 .253-.515 8.525 8.525 0 0 0-5.49-.71 8.586 8.586 0 0 0-5.252 3.366.287.287 0 0 0 .062.401zM6.127 15.592c-.002-.006-.006-.011-.008-.018a7.96 7.96 0 0 1 .724-5.231.287.287 0 1 0-.51-.262 8.529 8.529 0 0 0-.775 5.625c.003.011.009.02.012.03.023.113.048.225.075.337a.287.287 0 0 0 .558-.138 7.666 7.666 0 0 1-.076-.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.708 7.597a6.495 6.495 0 0 0-5.146 5.288.288.288 0 0 0 .566.099 5.924 5.924 0 0 1 4.694-4.824 5.964 5.964 0 0 1 7.022 4.692c.052.26.097.518.133.767a.287.287 0 1 0 .569-.083 16.103 16.103 0 0 0-.15-.852c-.725-3.517-4.167-5.797-7.688-5.087z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.325 13.534a2.358 2.358 0 0 0-1.013-1.508 2.372 2.372 0 0 0-3.636 1.493.288.288 0 0 0 .562.117 1.797 1.797 0 0 1 3.521.013c.146.72.22 1.457.223 2.187a.287.287 0 0 0 .574-.001 11.81 11.81 0 0 0-.226-2.264.315.315 0 0 0-.005-.037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.283 13.947a.288.288 0 0 0-.563.113 9.03 9.03 0 0 1-2.085 7.801.288.288 0 0 0 .216.477c.08 0 .159-.033.215-.097a9.602 9.602 0 0 0 2.217-8.294zM22.444 12.3c-.002-.009-.008-.015-.01-.024a8.577 8.577 0 0 0-3.488-5.324.288.288 0 0 0-.33.47 8.007 8.007 0 0 1 3.26 4.992l.008.022c.114.572.166 1.153.156 1.73a.288.288 0 0 0 .281.293h.006a.287.287 0 0 0 .287-.282 8.706 8.706 0 0 0-.17-1.877z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.363 13.123a4.424 4.424 0 0 0-1.9-2.83 4.422 4.422 0 0 0-3.344-.656 4.46 4.46 0 0 0-3.484 5.247.293.293 0 0 0 .015.049c.092.48.112.967.06 1.448-.017.157.097.3.255.316a.29.29 0 0 0 .316-.255 5.488 5.488 0 0 0-.078-1.673.287.287 0 0 0-.014-.048 3.884 3.884 0 0 1 3.044-4.52 3.85 3.85 0 0 1 2.912.57 3.855 3.855 0 0 1 1.652 2.448l.003.018c.319 1.583.349 3.188.089 4.77a.288.288 0 0 0 .567.092 13.78 13.78 0 0 0-.09-4.957l-.003-.019zM20.383 14.602a.287.287 0 0 0-.269.305 15.246 15.246 0 0 1-.484 4.89.287.287 0 1 0 .555.147c.441-1.656.61-3.363.502-5.073a.285.285 0 0 0-.304-.269zM17.967 19.071a.286.286 0 0 0-.352.203 13.295 13.295 0 0 1-.888 2.378.287.287 0 0 0 .517.252c.386-.794.698-1.628.926-2.48a.287.287 0 0 0-.203-.353z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.23 16.87a.288.288 0 0 0-.319.254 11.223 11.223 0 0 1-1.882 5.042.287.287 0 1 0 .474.325 11.795 11.795 0 0 0 1.98-5.302.288.288 0 0 0-.254-.318z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerHangUpdate);
export default __webpack_public_path__ + "static/media/finger_hang_update.f72377c23a8efb6a956aa54d978c1112.svg";
export { ForwardRef as ReactComponent };